
<div class="pag-container">
<!-- <h1>{{labelTest}}</h1> -->
  <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>

  <h1 class="bold-text header-blue" style="margin-top:20px"> {{ 'distributionList.actionList' | translate }}</h1>
  <h3 class="thin-text header-blue"> {{ 'distributionList.promoview_descr' | translate }} {{routeParams}} </h3>

  <div class="ui-g-12 prova" *ngIf="showTable">
    <app-campaign-3-kontable 

#promoListDetailKontable           
[columns] = "[         
{ field: 'id', title: 'distributionList.id',filterType: textFilter },
{ field: 'campaign_name', title: 'distributionList.campaignName',filterType: textFilter},
{ field: 'name', title: 'distributionList.actionName',filterType: textFilter},
{ field: 'rule_scope', title: 'distributionList.scope',filterType: selectFilter, filterOptions: { values: scopeList } ,bodyTemplate: rulescopeTemplate },
{ field: 'code', title: 'distributionList.emission',filterType: textFilter,bodyTemplate: emissionTemplate,sortable:false },
{ field: 'code', title: 'distributionList.fruition', filterType: textFilter,bodyTemplate: fruitionTemplate,sortable: false },
{ field: 'status', title: 'distributionList.status' , filterType: selectFilter, filterOptions: { values: actionStatusList } , bodyTemplate: statusTemplate}
]"
     
[paginationType]="paginationType"
[showInfoButton]="false"            
[showDetailsButton]="false"
[showRecoverButton]="false"
[showAddButton]="false"
[showDeleteButton]="false"
[showEditButton]="false"
[showDeleteButton]="false"
[allowSelectRow]="false"
[additionalRowCommands]="actions"
[filterBySingleColumn]="true"
[source]="distributionPromoList"
>
    
<ng-template #statusTemplate let-row>
  <span class="center-number"> {{
      translateState(row.status)
    }}</span>
</ng-template>



<ng-template #rulescopeTemplate let-row>
  <span class="center-number"> {{
      translateRulescope(row.rule_scope)
    }}</span>
</ng-template>


<ng-template #emissionTemplate let-row>
  <div class="template-column">
    <span > 
      {{ row.start_emission_date }}
    </span>
    <span > 
      {{ row.end_emission_date }}
    </span>
  </div>
</ng-template>

<ng-template #fruitionTemplate let-row>
  <div class="template-column">
    <span >
      {{ row.start_fruition_date }}
    </span>
    <span>
      {{ row.end_fruition_date }}
    </span>
  </div>
</ng-template>

<ng-template #actions let-row>

  <div class="d-flex justify-content-center ">
    <button data-testid-generic="goToAction" (click)="goToTheAction(row)" [attr.data-testid]="'goToAction' + row.id"
      pTooltip="{{ 'distributionList.goToAction' | translate }}" class="roundedButton row-buttom-margin">
      <i class="pi pi-eye icon-size"></i>
    </button>

  </div>

</ng-template>

</app-campaign-3-kontable>  
   </div> 
 
  
</div>


// WEBPACK FOOTER //
// ./src/app/views/distribution-list/promo-list-detail-3/promo-list-detail-3.component.html